var _path, _rect, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.797,
    d: "M187.378 116.636c7.804-47.84-24.653-92.95-72.494-100.754-47.84-7.804-92.95 24.653-100.754 72.494-7.804 47.841 24.653 92.95 72.494 100.754 47.841 7.804 92.95-24.653 100.754-72.494z",
    fill: "url(#CheckPhone_svg__paint0_linear_6674_2561)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 34,
    width: 72,
    height: 137,
    rx: 8,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#CheckPhone_svg__filter0_i_6674_2561)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFE5",
    d: "M74 51h55v106H74z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D9D9D9",
    d: "M74.5 51.5h54v105h-54z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#CheckPhone_svg__filter1_d_6674_2561)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 42,
    width: 29,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "CheckPhone_svg__filter0_i_6674_2561",
    x: 74,
    y: 51,
    width: 55,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_6674_2561"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "CheckPhone_svg__filter1_d_6674_2561",
    x: 84.7,
    y: 40.7,
    width: 33.6,
    height: 7.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6674_2561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6674_2561",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CheckPhone_svg__paint0_linear_6674_2561",
    x1: 14.13,
    y1: 88.376,
    x2: 187.378,
    y2: 116.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0528A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#780382"
  })))));
}
export default SvgCheckPhone;